import {createFakeTeam} from 'app/demo/demo_fixtures/teams';

import {teamListSource} from '../../demo_fixtures';
import {EventEmitter} from '../../EventEmmiter';
import {useData, waitAndReturn} from '../../utils';

export const TEAMTAG = 'team';

export const useTeams = () => {
  const {isFetching, data} = useData(
    teamListSource,
    'teamsUpdate',
    eventEmitter
  );

  return {
    isFetching,
    data,
    refetch: () => {
      eventEmitter.emit('teamsUpdate', teamListSource);
    },
  };
};

export const useTeamDetail = () => ({});

const createTeam = ({name}) => {
  return {
    unwrap: () => {
      return waitAndReturn(() => {
        const newTeam = createFakeTeam(name);
        teamListSource.results.push(newTeam);
        teamListSource.count = teamListSource.results.length;
        eventEmitter.emit('teamsUpdate', teamListSource);
        return newTeam;
      });
    },
  };
};
export const useCreateTeam = () => [createTeam];

export const extendedAPI = {
  endpoints: {
    getTeamDetail: {
      matchFulfilled: () => false,
    },
    createTeam: {
      matchFulfilled: () => false,
    },
    updateTeam: {
      matchFulfilled: () => false,
    },
  },
};

export const eventEmitter = new EventEmitter();
